export class MathUtils {
    /**
     * Returns a mathematical average of the provided number list by adding all numbers together and
     * dividing by the array length.
     * @param values the array of numbers for which to calculate the average.
     */
    public static average(values: number[]) {
        return MathUtils.sum(values) / values.length;
    }

    /**
     * Returns a sum of all elements in the array.
     * @param values the array of numbers to calculate a sum for.
     */
    public static sum(values: number[]) {
        let total = 0;
        values.forEach(v => total += +v);
        return total;
    }
}
